import { AlertTriangle } from 'lucide-react';

interface UnsavedChangesDialogProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  /** Clase de z-index. Debe quedar por encima del modal que la dispara (DialogShell la deriva de su `level`). */
  zIndexClass?: string;
}

export function UnsavedChangesDialog({ show, onCancel, onConfirm, zIndexClass = 'z-[60]' }: Readonly<UnsavedChangesDialogProps>) {
  if (!show) return null;

  return (
    <div data-modal-overlay="true" className={`fixed inset-0 bg-black/50 flex items-center justify-center ${zIndexClass} p-4`}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-amber-100 p-2 rounded-lg">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-800">¿Cerrar sin guardar?</h3>
            <p className="text-slate-600 text-sm">Tienes cambios sin guardar que se perderán.</p>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-semibold"
          >
            Continuar editando
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-semibold"
          >
            Cerrar sin guardar
          </button>
        </div>
      </div>
    </div>
  );
}
